import YRadio from './src/main'

YRadio.install = function(Vue) {
  Vue.component(YRadio.name, YRadio)
}

export default YRadio
